import React from 'react';
import { Layout, Avatar, Space, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useResponsive } from '../../hooks/useResponsive';

const { Header } = Layout;
const { Text } = Typography;

/**
 * 应用头部组件（极简版）
 *
 * 特性:
 * - 显示标题
 * - 只显示用户头像和名称（无菜单）
 */
const AppHeader: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { isMobile } = useResponsive();

  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
        padding: isMobile ? '0 16px' : '0 24px',
        boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
        zIndex: 10,
        height: isMobile ? '56px' : '64px',
        position: 'sticky',
        top: 0,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <Text
            strong
            style={{
              fontSize: isMobile ? '16px' : '18px',
              color: '#0ea5e9'
            }}
          >
            {isMobile ? t('header.title') : t('header.subtitle')}
          </Text>
          {import.meta.env.VITE_IS_PRODUCTION !== 'true' && (
            <span
              style={{
                marginLeft: '8px',
                padding: '2px 8px',
                backgroundColor: '#ff4d4f',
                color: '#fff',
                fontSize: isMobile ? '10px' : '12px',
                fontWeight: 'bold',
                borderRadius: '4px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              测试环境
            </span>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Space size={isMobile ? 'small' : 'middle'}>
          <Avatar
            size={isMobile ? 'small' : 'default'}
            icon={<UserOutlined />}
            style={{ backgroundColor: '#0ea5e9' }}
          />
          {!isMobile && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Text strong>{user?.name || ''}</Text>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {user?.role === 'admin' ? t('roles.admin') : user?.role === 'teacher' ? t('roles.teacher') : t('roles.parent')}
              </Text>
            </div>
          )}
        </Space>
      </div>
    </Header>
  );
};

export default AppHeader;
